import { graphql } from "react-relay";

export const logout = graphql`
  mutation LogoutMutation($input: LogoutInput!) {
    logout(input: $input) {
      success
      errors
    }
  }
`;
